import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './Routes';
import AuthProvider from './contexts/AuthContext'
import { SoundProvider } from './contexts/SoundContext';
import { AudioUnlocker } from './components/AudioUnlocker';
import { Provider } from 'react-redux';
import './App.css';

import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import store from './redux/store/store';
import ReAuth from './ReAuth';
import InitialRedirect from './InitialRedirect';
import RouteTracker from './RouteTracker';
import ChatWidget from './features/chat/chatWidget';

function App() {

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <SoundProvider>
            <AudioUnlocker />
            {/* <ReAuth />  */}
            <Router>
              {/* <InitialRedirect/> */}
              <RouteTracker />
              <AppRoutes />
              {/* <ChatWidget /> */}
            </Router>
          </SoundProvider>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;